<template>
    <select v-model="reserveValue">
        <option :value="null">All</option>
        <option value="25000"><£25,000</option>
        <option value="50000">£25,000&ndash;£49,999</option>
        <option value="10000">£50,000&ndash;£100,000</option>
        <option value="150000">£100,000&ndash;£150,000</option>
        <option value="-1">£150,000+</option>
        <option value="own">Enter Own Range</option>
    </select>
</template>

<script>
    export default {
        name: 'reserve-value',
        computed: {
            reserveValue: {
                get() {
                    return this.$store.getters['dashboards/reserveValue'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'reserveValue', value})
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ReserveValue.vue?0b6bc459